import React, { Fragment } from "react";

// import CompanyVideo from "../../../videos/profile_video.mp4";
import CompanyImage from "../../../img/comcast_nbcuniversal.jpg";

const CompanyBackgroundPicVideo = ({ setprofilePicOpen }) => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          <img src={CompanyImage} alt="avatar" className="background-image" />
          <div className="profile-user-info">
            {/* {user && user.user === profile.user ? ( */}
            <div
              className="profile-user-info-button-blue blue"
              // onMouseOver={() => setColor(true)}
              // onMouseLeave={() => setColor(false)}
            >
              {/* <Link to={`/${user.channelid}/edit`}> */}
              <span
              // className={color ? "black" : "blue"}
              // onClick={() => setEditing(true)}
              >
                Edit Profile
              </span>
              {/* </Link> */}
            </div>
            ) : (
            {/* <div
              className="profile-user-info-button-blue blue"
              // onClick={() => setemployerbio(true)}
            >
              Biography
            </div> */}
            {/* )} */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyBackgroundPicVideo;
